function removeURLParams(url) {
  return url?.split('?')[0];
}

export const processSource = ({ source, sort = 'default' }) => {
  let result = null;
  let firstItemType = '';
  const firstURLParamless = removeURLParams(source[0]?.url);

  if (firstURLParamless) {
    result = firstURLParamless.replace(
      /(https|http)?(:\/\/)?(www.)?(vimeo.com\/)?/g,
      ''
    );

    if (result.split('/')[0].includes('channels')) {
      firstItemType = 'channel';
    }

    if (result.split('/')[0].includes('groups')) {
      firstItemType = 'group';
      sort = 'date';
    }

    if (result.split('/')[0].includes('ondemand')) {
      result = result.replace('ondemand', 'ondemand/pages');
      firstItemType = 'page';
    }

    if (result.split('/')[0].includes('album')) {
      result = result.replace('album', 'albums');
      firstItemType = 'album';
    }

    if (result.split('/')[0].includes('showcase')) {
      result = result.replace('showcase', 'albums');
      firstItemType = 'album';
    }

    if (Number(result, 10)) {
      result = `videos/${result}`;
      firstItemType = 'video';
    }

    if (!result) {
      result = '';
      firstItemType = 'empty';
    }

    if (!firstItemType) {
      result = `users/${result}`;
      firstItemType = 'user';
    }
  }

  if (firstItemType !== 'video') {
    return {
      source: result,
      type: firstItemType,
      sort
    };
  } else {
    return {
      source: source.reduce((accumulator, { url }) => {
        const paramlessURL = removeURLParams(url);
        if (paramlessURL) {
          accumulator.push(
            'videos/' +
              paramlessURL.replace(
                /(https|http)?(:\/\/)?(www.)?(vimeo.com\/)?/g,
                ''
              )
          );
        }
        return accumulator;
      }, []),
      type: 'videos',
      sort
    };
  }
};
